import { search } from "../../../BaseRepositoryComponents";

const searchParams = new URLSearchParams(window.location.search);

const path = `${process.env.REACT_APP_URL_API_REPORTS}/servicecontract`;

const documentsHubPath = `${process.env.REACT_APP_URL_API_DOC_HUB}/reports`;

const headers = new Headers();
const token = `Bearer ${searchParams.get("gfAccessToken") || ""}`;
headers.append("Authorization", token);
headers.append("content-type", "application/json");

export async function findServiceContract(filter) {
  const url = new URL(path);
  Object.entries(filter).forEach(([key, value]) => {
    if (value) {
      url.searchParams.append(key, value);
    }
  });

  return search(decodeURIComponent(url), "GET", headers);
}

export async function findContractType() {
  const url = new URL(
    `${process.env.REACT_APP_URL_API_ERP_V3}/multitenant/tipo-contrato`
  );

  url.searchParams.append("perPage", 50);

  return search(decodeURIComponent(url), "GET", headers);
}

export async function printServiceContractPDF(body) {
  const url = `${documentsHubPath}/service-contract/generate`;

  return search(`${url}`, "POST", headers, body);
}
